var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:phone-bold"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.27794 7.29283L8.05044 7.51933C8.05044 7.51933 7.50894 8.05733 6.03144 6.58833C4.55394 5.11933 5.09544 4.58133 5.09544 4.58133L5.23844 4.43833C5.59194 4.08733 5.62544 3.52333 5.31694 3.11133L4.68694 2.26983C4.30494 1.75983 3.56744 1.69233 3.12994 2.12733L2.34494 2.90733C2.12844 3.12333 1.98344 3.40233 2.00094 3.71233C2.04594 4.50583 2.40494 6.21233 4.40694 8.20333C6.53044 10.3143 8.52294 10.3983 9.33744 10.3223C9.59544 10.2983 9.81944 10.1673 9.99994 9.98733L10.7099 9.28133C11.1899 8.80483 11.0549 7.98733 10.4409 7.65383L9.48594 7.13433C9.08294 6.91583 8.59294 6.97983 8.27794 7.29283Z",
    fill: "#5881FE",
    fillOpacity: 0.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.1b5b81cf987517250f63dfda72d5d6cc.svg";
export { ForwardRef as ReactComponent };